/* eslint-disable @typescript-eslint/no-explicit-any */
import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { AbstractControl, ControlValueAccessor, Validator } from '@angular/forms';

@Directive({
  })
export abstract class ValueAccessorBase<T> implements ControlValueAccessor, Validator {
    private _value: T | undefined;
    private _viewValue: string = '';

    constructor(private _renderer: Renderer2, private _elementRef: ElementRef) {
    }

    protected abstract format(n: T | undefined): string;
    protected abstract isValidChar(c: string): boolean;
    protected abstract parse(value: string): { parsed: T | undefined, errors: any };

    get value(): T | undefined {
        return this._value;
    }

    set value(val: T | undefined) {
        this._value = val;
        this._onChange(val);
    };

    writeValue(val: T): void {
        this._value = val;
        this.render();
    }

    private render(): void {
        this._viewValue = this.format(this._value);
        this._renderer.setProperty(this._elementRef.nativeElement, 'value', this._viewValue);
    }

    private _onChange = (_: any) => { };
    registerOnChange(fn: (_: any) => void): void {
        this._onChange = fn;
    }

    private _onTouched = () => { };
    registerOnTouched(fn: () => void): void {
        this._onTouched = fn;
    }

    validate(control: AbstractControl) {
        const value = this._viewValue;
        if (value.length > 0) {
            const result = this.parse(value);
            return result.errors;
        }
        return null;
    }

    @HostListener('input', ['$event'])
    onInput(e: any) {
        const event = e || window.event;
        this._viewValue = event.target['value'];
        const result = this.parse(this._viewValue);
        this.value = result.parsed;
    }

    @HostListener('keypress', ['$event'])
    onKeypress(e: any) {
        const event = e || window.event;

        let char: string;
        if (event.which == null) {
            char = String.fromCharCode(event.keyCode);    // old IE
        } else if (event.which !== 0 && event.charCode !== 0) {
            char = String.fromCharCode(event.which);	  // All others
        } else {
            return true;
        }

        if (!this.isValidChar(char)) {
            event.preventDefault();
        }
    }

    @HostListener('blur')
    onBlur() {
        this._onTouched();
        if (this._value !== undefined) {
            this.render();
        }
    }
}
